import { Alert } from "@mantine/core";
import { captureException } from "@sentry/nextjs";
import React from "react";
import { AlertTriangle } from "react-feather";
import { trackEvent } from "./Analytics/gtag";
import Button from "./Button";

type ErrorBoundaryProps = {
  children: React.ReactNode;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  state = { hasError: false };

  constructor(props: ErrorBoundaryProps) {
    super(props);
  }
  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }
  componentDidCatch(error: Error, errorInfo: any) {
    console.log({ error, errorInfo });

    trackEvent({
      action: "error",
      category: "error",
      label: error.message,
    });
    captureException(error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <Alert
          color="red"
          icon={<AlertTriangle size={16} />}
          title="Fehler während der Anzeige"
          className="my-3"
        >
          <Button
            color="red"
            variant="outline"
            type="button"
            onClick={() => this.setState({ hasError: false })}
          >
            Erneut versuchen
          </Button>
        </Alert>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
